import { Layout, Row, Col, List, Icon, Modal, Button, Divider } from "antd";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { RouteComponentProps, withRouter } from "react-router";
import bindAllOfThis from "src/utils/BindThisHelper";
import * as React from "react";
import '../Footer.less';

const logo = require('src/assets/branding/logo-small-white.png');
const { Footer } = Layout;

interface PublicFooterProps extends LocalizeContextProps {
}

class PublicFooter extends React.Component<PublicFooterProps> {
    constructor(props: PublicFooterProps) {
        super(props);
        bindAllOfThis(this, Footer.prototype);
    }

    renderLinks(): JSX.Element {
        var links = [
            { id: "contact-us", text: this.props.translate("public.footer.contact"), link: "contact-us" },
            { id: "help", text: this.props.translate("public.footer.help"), link: "help" },
            { id: "privacy-policy", text: this.props.translate("public.footer.privacy"), link: "privacy-policy" },
            { id: "terms-of-use", text: this.props.translate("public.footer.tou"), link: "terms-of-use" }
        ];

        return (
            <ul id="kuder-links" className="kuder-links">
                {links.map(link => (
                    <li tabIndex={-1} key={link.id}>
                        <a tabIndex={3} href={`http://kuder.com/${link.link}`} target="_blank">
                            {link.text}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }
    
    renderIcons(): JSX.Element {
        var icons = [
            { id: "linkedin", name: "LinkedIn", className: "fab fa-linkedin-in", link: "http://us.linkedin.com/company/kuder" },
            { id: "youtube", name: "YouTube", className: "fab fa-youtube", link: "http://www.youtube.com/user/kuder" },
            { id: "blog", name: "Kuder Blog", className: "fas fa-rss", link: "http://www.kuder.com/blog" },
            { id: "facebook", name: "Facebook", className: "fab fa-facebook", link: "http://www.facebook.com/KuderCareerPlanningSystem" },
            { id: "twitter", name: "Twitter", className: "fab fa-twitter-square", link: "https://twitter.com/kuder" },
        ];

        return (
            <ul id="kuder-icons" className="kuder-icons">
                {icons.map(icon => (
                    <li tabIndex={-1} id={icon.id} key={icon.id}>
                        <a tabIndex={3} href={icon.link} title={icon.name} className="footerIcon" target="_blank">
                            <p className="screen-reader-hidden">SOMETHING</p>
                            <div className={icon.className}></div>
                        </a>
                    </li>
                ))}
            </ul>
        );
    }

    public renderYear() {
        var d = new Date();
        return d.getFullYear();
    }

    public render() {
        return <Footer className="footer">
            <Row type="flex" justify="space-between">
                <Col xs={{ span: 11, push: 1 }} sm={6} md={{ span: 6, push: 1 }} lg={{ span: 5, push: 2 }}>
                    <a tabIndex={-1} href={"http://www.kuder.com/"} className="logo" target="_blank">
                        <img src={logo} alt="Kuder" height="33" width="148" />
                    </a>
                    <p>&copy; {this.renderYear()} {this.props.translate("public.footer.inc")}</p>
                    {this.props.children}
                </Col>

                <Col xs={{ span: 11, pull: 1 }} sm={{ span: 6, pull: 0 }} md={8} lg={6}>
                    {this.renderLinks()}
                </Col>

                <Col xs={{ span: 22, push: 1, pull: 1 }} sm={{ span: 6, push: 0, pull: 1 }} md={{ span: 6, push: 0, pull: 1 }} lg={{ span: 5, push: 0, pull: 2 }}>
                    {this.renderIcons()}
                </Col>
            </Row>
        </Footer>;
    }

}

export default withLocalize(PublicFooter);



// WEBPACK FOOTER //
// ./src/layouts/public/PublicFooter.tsx